export const pageTheme = {
  baseStyle: {
    container: {
      bg: 'transparent',
    },
    body: {
      overflowX: 'hidden',
      bg: 'transparent',
      '& > div': {
        bg: 'transparent',
      },
    },
  },
  defaultProps: {
    // this variant adds spacing next to the title for the sidebar toggle button on mobile screens.
    variant: 'default-sidebar',
  },
};
